<template>
    <Head title="Create New Manufacturer" />
    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Create New Manufacturer
            </h2>
        </template>
        <BreadCrumbs :items="navItems"></BreadCrumbs>
        <div class="w-full my-6 overflow-hidden py-12 shadow">
            <div class="px-6 pt-4 pb-2">
                <form @submit.prevent="create.post(requestUrl, { preserveScroll: true})" class="w-full">
                    <div class="mb-6 md:mb-4">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
                            <div class="col-span-2 md:mb-4">
                                <admin-app-label>Name</admin-app-label>
                                <input-basic
                                    placeholder="Name"
                                    v-model="create.name"
                                    :error="errors['name']"
                                />
                                <input-error v-if="errors['name']">
                                    {{ errors.name }}
                                </input-error>
                            </div>
                            <div class="mb-6 md:mt-6 md:mb-4">
                                <input-checkbox v-model="create.featured">
                                    Featured
                                </input-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>New Image</admin-app-label>
                        <image-upload
                            :key="`Image`"
                            :label="`Image`"
                            v-model="create.image"
                            :error="errors['image']"
                        >
                        </image-upload>
                        <input-error v-if="errors['image']">
                            {{ errors.image }}
                        </input-error>
                    </div>
                    <div class="mb-6 md:mb-4">
                        <admin-app-label>Description</admin-app-label>
                        <input-wysiwyg
                            v-model="create.description"
                        ></input-wysiwyg>
                        <input-error v-if="errors['description']">
                            {{ errors.description }}
                        </input-error>
                    </div>
                    <seo-tags v-model="create.seo_tags" :errors="errors"></seo-tags>
                    <app-button type="submit" :disabled="create.processing" class="mt-8">Create</app-button>
                </form>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
<script>
import {useForm} from "@inertiajs/inertia-vue3";
import BreezeAuthenticatedLayout from "@/Layouts/Admin/Authenticated.vue";
import {Head} from "@inertiajs/inertia-vue3";
import Label from "@/Components/Label";
import InputCheckbox from "@/Components/Forms/Inputs/InputCheckbox";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
import AppButton from "@/Components/AppButton";
import InputError from "@/Components/Forms/Inputs/InputError";
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import BreadCrumbs from "@/Components/Admin/BreadCrumbs";
import InputWysiwyg from "@/Components/Admin/Forms/Inputs/InputWysiwyg";
import ImageUpload from "@/Components/Admin/Forms/Inputs/ImageUpload";
import SeoTags from "@/Components/Admin/Forms/SeoTags";

export default {
    components: {
        SeoTags,
        BreadCrumbs,
        AdminAppLabel,
        AppButton,
        InputBasic,
        Label,
        BreezeAuthenticatedLayout,
        Head,
        InputError,
        InputWysiwyg,
        ImageUpload,
        InputCheckbox
    },
    props: {
      name: String,
      errors: Object,
      requestUrl: {
          type: String,
          default: '/admin/manufacturers'
      }
    },
    data() {
        return {
            navItems: [
                { title: 'Manufacturers', path: '/admin/manufacturers' },
                { title: 'Create New', path: '/admin/manufacturers/create' },
            ],
            create: useForm(
                {
                    name: "",
                    image: null,
                    description: "",
                    seo_tags: null
                }
            )
        }
    }
}
</script>
